import React from 'react';
import { SvgProps } from './icon.types';

function BellIcon({ fillColor = '#2D3049', title, ...props }: SvgProps) {
  return (
    <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M16 20v2H8v-2h8zM12 2a3 3 0 013 3l.12.04c.65.2 3.73 1.42 3.87 5.65L19 11v3l2 1v4H3v-4l2-1v-3c0-5 4-6 4-6a3 3 0 013-3zm0 2a1 1 0 00-1 .88V6.56l-1.52.38c-.37.11-2.36.83-2.47 3.79L7 11v4.24l-2 1V17h14v-.76l-2-1V11c0-3.02-1.94-3.87-2.4-4.03l-.08-.03L13 6.56V5a1 1 0 00-1-1z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { BellIcon };
